<template>
  <el-dialog
      :visible.sync="visible"
      title=""
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="800px"
      :append-to-body="true"
  >
    <el-form
        ref="dataForm"
        :model="dataForm"
        :rules="dataRule"
        label-width="120px"
    >
      <el-form-item prop="receiptCode" label="进出口发票号：">
        <el-input v-model="dataForm.receiptCode" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item prop="amount" label="发票金额：">
        <el-input v-model="dataForm.amount"></el-input>
      </el-form-item>
<!--      <el-form-item prop="remark" label="备注：">-->
<!--        <el-input v-model="dataForm.remark" type="textarea" :rows="8"></el-input>-->
<!--      </el-form-item>-->
    </el-form>
    <template slot="footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">保存</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
import { moneyValidator } from '@/utils/validate'

export default {
  name: 'amount-dialog',
  data () {
    return {
      visible: false,
      data: {},
      dataRule : {
        amount: [
          { required: true, message: '请输入金额', trigger: 'change' },
          { validator: moneyValidator, trigger: 'change' }],
      },
      dataForm: {
        id: '',
        amount: '',
        remark: ''
      }
    }
  },
  methods: {
    init (data) {
      this.visible = true
      this.$nextTick(() => {
        this.reset()
        this.dataForm = {
          ...this.dataForm,
          id: data.id,
          receiptCode: data.receiptCode,
        }
      })
    },
    reset () {
      if (this.$refs.dataForm) {
        this.$refs.dataForm.resetFields()
      }
    },
    cancel () {
      this.visible = false
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        let postForm = {
          ...this.dataForm,
          virtualCode:this.dataForm.receiptCode
        }
        this.$http.post('/trade/code/remark', postForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$emit('change')
          this.$c.success('操作成功').then(() => {
            this.cancel()
          })
        }).catch(() => {
        })
      })
    }, 1000, { 'leading': true, 'trailing': false }),
  }
}

</script>

<style lang='scss' scoped>

</style>
